import React from 'react';
import {
  Modal,
  Text,
  Button,
  FormButton,
} from '@cochlear-design-system/foundation';

const ReturnLoanerModal = ({
  labels,
  onSubmit,
  onClose,
  visible,
  isSubmitting,
}) => (
  <Modal dialogClassName="return-loaner-modal" show={visible}>
    <Modal.Header
      closeButton
      onHide={onClose}
      data-analytics="cancel_header_return_loaner"
    >
      <Modal.Title>
        {labels['labels.clinicEquipment.returnLoaner.dialog.title']}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Text
        content={
          labels['labels.clinicEquipment.returnLoaner.dialog.message']
        }
      />
    </Modal.Body>
    <Modal.Footer>
      <FormButton
        onClick={onSubmit}
        text={labels['labels.common.confirm']}
        progress={isSubmitting ? 2 : undefined}
        type="save"
        data-analytics="confirm_return_loaner"
      />
      <Button
        variant="tertiary"
        onClick={onClose}
        text={labels['labels.common.cancel']}
        data-analytics="cancel_return_loaner"
      />
    </Modal.Footer>
  </Modal>
);

export default ReturnLoanerModal;
